'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEW_ACTION = exports.VIEW_AVAILABILITY_EVENT = exports.AVAILABILITY_GTM_CATEGORY = undefined;
exports.composeViewAvailabilityEvent = composeViewAvailabilityEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AVAILABILITY_GTM_CATEGORY = exports.AVAILABILITY_GTM_CATEGORY = _constantsAnalytics2.default.CATEGORIES.AVAILABILITY;

var VIEW_AVAILABILITY_EVENT = exports.VIEW_AVAILABILITY_EVENT = _constantsAnalytics2.default.EVENTS.CHECK_AVAILABILITY;

var VIEW_ACTION = exports.VIEW_ACTION = _constantsAnalytics2.default.ACTIONS.VIEW;

function composeAvailabilityEvent(eventName, eventValue, eventAction, eventLabel) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: eventValue,
    gtmAction: eventAction,
    gtmCategory: AVAILABILITY_GTM_CATEGORY,
    gtmLabel: eventLabel
  });
}

function composeViewAvailabilityEvent(status) {
  return (0, _compose.composeAnalytics)([composeAvailabilityEvent(VIEW_AVAILABILITY_EVENT, 1, VIEW_ACTION, status && status.toLowerCase())]);
}

exports.default = {
  AVAILABILITY_GTM_CATEGORY: AVAILABILITY_GTM_CATEGORY,
  VIEW_AVAILABILITY_EVENT: VIEW_AVAILABILITY_EVENT,
  VIEW_ACTION: VIEW_ACTION,
  composeViewAvailabilityEvent: composeViewAvailabilityEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/availabilityEventComposer.js
// module id = 548
// module chunks = 0 2 4 6 7 8 9 10